import axios from "axios";
const { REACT_APP_SAEP_URL } = process.env;

async function getNextDeparturesByCode(code: string, curIsland: string) {
    const res = await axios.get(`${REACT_APP_SAEP_URL}/next-departures/${curIsland}/${code}`);
    return res.data;
}

export const SaepApi = {
    getNextDeparturesByCode
};